<template>
  <div>
    <div class="page-title">New Review</div>
    <Form btnText="Add Project" v-model="form" :submit="create" />
  </div>
</template>

<script>
import Form from "./_form.profile_reviews.page";
export default {
  components: { Form },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.ProfileReview.new();
      this.form = data;
    },
    async create() {
      await this.$api.ProfileReview.create(this.form);
      this.$router.push(`/users/participants/${this.form.user_id}?tab=2`);
    },
  },
};
</script>

<style></style>
